import { render } from "./returnVisit.vue?vue&type=template&id=54213e04&scoped=true"
import script from "./returnVisit.vue?vue&type=script&lang=js"
export * from "./returnVisit.vue?vue&type=script&lang=js"

import "./returnVisit.vue?vue&type=style&index=0&id=54213e04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54213e04"

export default script